





import app from "@/app";
import { SXCompany, SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WCompanyAdd extends BaseComponent {
	title = "SX_LANG_COMPANY_ADD";
	loading = false;

	get form() {
		return getForm(this.sectors);
	}
	get sectors() {
		return app.services.sectors.list();
	}

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [
				SXCompany.COL_SECTOR_ID,
				SXCompany.COL_NAME,
				SXCompany.COL_DESCRIPTION
			],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let formData = fv.getFormData(),
				customData = {
					bg_color: fv.getField("bg_color"),
					txt_color: fv.getField("txt_color")
				};

			if (!fv.getField(SXCompany.COL_VISIBILITY)) {
				formData.append(SXCompany.COL_VISIBILITY, "0");
			}

			formData.append(SXCompany.COL_DATA, JSON.stringify(customData));

			app.services.companies.add(formData, function() {
				app.router.goBack();
			});
		}
	}

	created() {
		if (!this.sectors.length) {
			let ctx = this,
				always = () => (ctx.loading = false);
			ctx.loading = true;
			app.services.sectors.loadSectors(always, false);
		}
	}
}

const getForm = function(sectors: SXSector[]) {
	let options = sectors.map(function(item) {
		return {
			attrs: { value: item.id },
			i18n: item.name
		};
	});

	return {
		fields: {
			sector: {
				field: "select",
				label: { i18n: "SX_LANG_SECTOR" },
				attrs: { name: SXCompany.COL_SECTOR_ID },
				options: options
			},
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXCompany.COL_NAME,
					minlength: 3,
					maxlength: 60,
					autocomplete: "off"
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXCompany.COL_DESCRIPTION,
					minlength: 3
				}
			},
			bg_color: {
				field: "input",
				label: { i18n: "SX_LANG_BG_COLOR" },
				attrs: {
					name: "bg_color",
					type: "color",
					value: "#233D7D"
				}
			},
			txt_color: {
				field: "input",
				label: { i18n: "SX_LANG_TXT_COLOR" },
				attrs: {
					name: "txt_color",
					type: "color",
					value: "#FFFFFF"
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXCompany.COL_VISIBILITY
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
